module.exports = __webpack_public_path__ + "static/media/icomoon.71e6c915.woff";